import { z } from 'zod';

/**
 * App Catalog schema — items from the ControlPlane DynamoDB table.
 *
 * Key pattern:
 *   PK = "APP#<app_code>"
 *   SK = "PLAN#<plan_code>#TIER#<tier_code>"
 */

export const CatalogIsolationModelEnum = z.enum(['SILO', 'POOL', 'BRIDGE', 'NA']);
export type CatalogIsolationModel = z.infer<typeof CatalogIsolationModelEnum>;

export const CatalogFeaturesSchema = z.record(z.string(), z.boolean());

export const CatalogItemSchema = z.object({
  app_code: z.string(),
  app_name: z.string(),
  plan_code: z.string(),
  plan_name: z.string(),
  tier_code: z.string(),
  tier_name: z.string(),
  isolation_model: CatalogIsolationModelEnum,
  features_json: CatalogFeaturesSchema,
  is_active: z.boolean(),
  sort_order: z.number().int(),
  created_at: z.string(),
});

export type CatalogItem = z.infer<typeof CatalogItemSchema>;

export const CatalogListQuerySchema = z.object({
  app_code: z.string().optional(),
});

export type CatalogListQuery = z.infer<typeof CatalogListQuerySchema>;
